import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { InfoCircleOutlined } from '@ant-design/icons';
import { useSelector } from 'react-redux';
import { Scrollbars } from 'react-custom-scrollbars';
import FeatherIcon from 'feather-icons-react';
import { Form, Row, Col, message, Drawer, Space, Spin, Modal } from 'antd';
import { BasicFormWrapper } from '../../styled';
import { AddUser } from '../style';
import TinyMCEEditor from "../EditorFolder/RichEmailEditor"
import { Button } from '../../../components/buttons/buttons';
import { addMeetingNote, fetchCalendarEventDetail } from '../../../Api/Services/MeetingApiService';
import { FetchAllAttendeeList } from '../../../Api/Services/CommonApiService';
import CustomHtmlParser from '../Email/CustomHtmlParser'
import { AddIcon, CancelIcon, EditIcon } from '../../../components/Icons/Icons';

const Popup = ({ modelOpen, handleClose, Meeting, emailCongifDetail, type, reFetchData1 }) => {
    const localData = useSelector((state) => state.localRedux);
    const ProfileData = localData.profile
    const profile = ProfileData
    const [form] = Form.useForm();
    const [displayData, setDisplayData] = useState()
    const [selectedItems, setSelectedItems] = useState([]);
    const [meetingSource, setMeetingSource] = useState()
    const [orgDetails, setOrgDetails] = useState()
    const handleClose1 = () => {
        handleClose()
        setSelectedItems([])
        setMeetingSource()
        setOrgDetails()
        setDisplayData()
    }
    const BodywithLinks = (data) => {
        const urlPattern = /(https?:\/\/[^\s]+)/g;
        const formattedMessage = data.replace(urlPattern, (url) => {
            const escapedUrl = encodeURIComponent(url);
            return `<a href="${escapedUrl}" target="_blank">${url}</a>`;
        });
        return formattedMessage.replace(/\n/g, '<br />');
    };
    // const extractTimezoneName = (tzStr) => {
    //     const match = tzStr.match(/^(.*)\s\d{2}:\d{2}:\d{2}$/)
    //     return match ? match[1] : "";
    // };
    const OutLookDateTimeForTimeZone = (dateTime) => {
        const DateTime = `${dateTime.replace(/\.\d+/, "")}.000Z`;
        const formatedDateTime = moment(DateTime, "YYYY-MM-DDTHH:mm:ss.Z").utc().format("YYYY-MM-DDTHH:mm:ss.000000");
        return formatedDateTime;
    }
    const ZohoDateTimeForTimeZone = (dateTime) => {
        const formatedDateTime = moment(dateTime, "YYYYMMDDTHHmmssZ").utc().format("YYYY-MM-DDTHH:mm:ss.000000");
        return formatedDateTime;
    }
    const convertTime = (timeStr, timeFormat) => {
        let hours;
        let minutes;
        let period;
        if (timeStr.toLowerCase().includes('am') || timeStr.toLowerCase().includes('pm')) {
            // Parse 12-hour time string
            const timeParts = timeStr.match(/(\d{1,2}):(\d{2})/);
            hours = parseInt(timeParts[1], 10);
            minutes = parseInt(timeParts[2], 10);
            period = timeStr.match(/(am|pm)/i)[0].toLowerCase();

            if (period === 'pm' && hours !== 12) {
                hours += 12;
            } else if (period === 'am' && hours === 12) {
                hours = 0;
            }
        } else {
            // Parse 24-hour time string
            const timeParts = timeStr.split(':');
            hours = parseInt(timeParts[0], 10);
            minutes = parseInt(timeParts[1], 10);
        }
        if (timeFormat === '12hrs' || timeFormat === '12-hour') {
            period = hours >= 12 ? 'PM' : 'AM';
            hours = hours % 12 || 12;
            return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')} ${period}`;
        }
        // No need for an else here because we return in the if above
        if (timeFormat === '24hrs' || timeFormat === '24-hour') {
            return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
        }
        throw new Error('Invalid time format specified');
    };
    const processOrgEmail = (response, participantData) => {
        let userData = participantData.find(item => item.email.toLowerCase() === response.email.toLowerCase());
        if (!userData) {
            userData = {
                id: "",
                name: response.email,
                type: "Others",
                email: response.email,
            };
        } else {
            userData = {
                id: userData.id,
                name: userData.name,
                type: userData.type,
                email: userData.email,
            };
        }
        return userData
    };
    const processAtteDetailsEmails = (responseEmails, participantData) => {
        const newUserList = responseEmails?.map(response => {
            let userData = participantData.find(item => item.email.toLowerCase() === response.email.toLowerCase());
            if (!userData) {
                userData = {
                    id: "",
                    name: response.email,
                    type: "Others",
                    email: response.email,
                    responseStatus: response.responseStatus
                };
            } else {
                userData = {
                    id: userData.id,
                    name: userData.name,
                    type: userData.type,
                    email: userData.email,
                    responseStatus: response.responseStatus
                };
            }
            return userData;
        });
        return newUserList;
    };
    function convertFromUTCAndFormat(dateTime, profile) {
        if (!dateTime || !profile?.timeZone) return "";
        // Extract IANA time zone name from full label like "(GMT+5:30) Asia/Kolkata"
        const extractTimezoneName = (tzStr) => {
            const match = tzStr.match(/\)\s*([A-Za-z/_]+)/);
            return match ? match[1] : "";
        };
        const toTimezone = extractTimezoneName(profile?.timeZone);
        if (!moment.tz.zone(toTimezone)) {
            console.warn("Invalid target time zone provided");
            return "";
        }
        // Step 1: Parse original and convert to UTC
        const utcTime = moment.parseZone(dateTime).utc();
        // Step 2: Convert UTC to desired profile time zone
        const converted = utcTime.clone().tz(toTimezone);
        // Step 3: Apply formats
        const dateFormat = profile?.dateFormate && profile?.dateFormate !== "" ? profile.dateFormate : "YYYY-MM-DD";
        const timeFormat = profile?.timeFormat && profile?.timeFormat !== "" ? profile.timeFormat : "24hrs";
        const rawTime = converted.format("HH:mm");
        const formattedTime = convertTime(rawTime, timeFormat); // Assume this handles 12/24-hour format
        return { date: converted.format(dateFormat), time: formattedTime };
    }
    function normalizeGoogleEventDate(node, profile, isEnd = false) {
        if (node.dateTime) {
            const { date, time } = convertFromUTCAndFormat(node.dateTime, profile);
            return { date, time };
        }
        if (node.date) {
            let dateStr = node.date;
            if (isEnd) {
                const [y, m, d] = dateStr.split('-').map(Number);
                const utcDate = new Date(Date.UTC(y, m - 1, d));
                utcDate.setUTCDate(utcDate.getUTCDate() - 1);
                dateStr = utcDate.toISOString().slice(0, 10);
            }
            const syntheticDateTime = isEnd
                ? `${dateStr}T23:59:59`
                : `${dateStr}T00:00:00`;

            const { date, time } = convertFromUTCAndFormat(syntheticDateTime, profile);
            return { date, time };
        }
        return null;
    }
    function convertFromUTCAndFormat1(dateTime, profile) {
        if (!dateTime || !profile?.timeZone) return "";

        // Extract IANA time zone name from full label like "(GMT+5:30) Asia/Kolkata"
        const extractTimezoneName = (tzStr) => {
            const match = tzStr.match(/\)\s*([A-Za-z/_]+)/);
            return match ? match[1] : "";
        };

        const toTimezone = extractTimezoneName(profile?.timeZone);
        if (!moment.tz.zone(toTimezone)) {
            console.warn("Invalid target time zone provided");
            return "";
        }

        // ✅ Step 1: Parse directly as UTC
        const utcTime = moment.utc(dateTime);

        // ✅ Step 2: Convert to desired profile time zone
        const converted = utcTime.clone().tz(toTimezone);

        // ✅ Step 3: Format date and time
        const dateFormat = profile?.dateFormate && profile?.dateFormate !== "" ? profile.dateFormate : "YYYY-MM-DD";
        const timeFormatPref = (profile?.timeFormat?.toLowerCase() === "12hrs" || profile?.timeFormat?.toLowerCase() === '12-hour') ? "h:mm A" : "HH:mm";

        return {
            date: converted.format(dateFormat),
            time: converted.format(timeFormatPref)
        };
    }
    const setData = async (value) => {
        if (value) {
            const data = await FetchAllAttendeeList()
            if (emailCongifDetail?.emailType === "Google") {
                const OrgDetailsData = processOrgEmail(value.organizer, data)
                setOrgDetails(OrgDetailsData)
                const onlyAttendees = value.attendees?.filter(item => item.organizer === undefined || item.organizer !== true)
                const AttendeesDetailsData = processAtteDetailsEmails(onlyAttendees, data)
                setSelectedItems(AttendeesDetailsData)
                setMeetingSource(value?.location || "");
                // const startTimeDate = convertFromUTCAndFormat(value?.start?.dateTime, profile)
                // const endTimeDate = convertFromUTCAndFormat(value?.end?.dateTime, profile)
                const fromInfo = normalizeGoogleEventDate(value?.start, profile, false);
                const toInfo = normalizeGoogleEventDate(value?.end, profile, true);
                const FinalData = {
                    ...value,
                    startDate: fromInfo.date,
                    startTime: fromInfo.time,
                    endDate: toInfo.date,
                    endTime: toInfo.time,
                };
                setDisplayData(FinalData)
            }
            if (emailCongifDetail?.emailType === "Outlook") {
                const OrgDetailsData = processOrgEmail({ email: value.event.organizer.emailAddress.address }, data)
                setOrgDetails(OrgDetailsData)
                setMeetingSource(value?.event?.location?.displayName || "");
                const onlyAttendees = value.event.attendees.filter(item => item.emailAddress.address !== value.event.organizer.emailAddress.address && item.emailAddress.address.toLowerCase() !== value.event.organizer.emailAddress.address.toLowerCase()).map(item => ({
                    email: item.emailAddress.address,
                    responseStatus: emailCongifDetail?.email.toLowerCase() === item.emailAddress.address.toLowerCase() ?
                        value.event.responseStatus.response === "notResponded" ? "needsAction" :
                            value.event.responseStatus.response === "tentativelyAccepted" ? "tentative" : value.event.responseStatus.response
                        :
                        item.status.response === "none"
                            ? "needsAction"
                            : item.status.response === "tentativelyAccepted"
                                ? "tentative"
                                : item.status.response,
                }));
                const AttendeesDetailsData = processAtteDetailsEmails(onlyAttendees, data)
                setSelectedItems(AttendeesDetailsData)
                const startFrom = OutLookDateTimeForTimeZone(value.event.start.dateTime)
                const endTo = OutLookDateTimeForTimeZone(value.event.end.dateTime)
                const startTimeDate = convertFromUTCAndFormat1(startFrom, profile)
                const endTimeDate = convertFromUTCAndFormat1(endTo, profile)
                const FinalData = {
                    ...value.event,
                    startDate: startTimeDate.date,
                    startTime: startTimeDate.time,
                    endDate: endTimeDate.date,
                    endTime: endTimeDate.time,
                };
                setDisplayData(FinalData)
            }
            if (emailCongifDetail?.emailType === "Zoho") {
                const OrgDetailsData = processOrgEmail({ email: value?.events[0].organizer }, data)
                setOrgDetails(OrgDetailsData)
                setMeetingSource(value?.event?.location || "");
                const onlyAttendees = value?.events[0].attendees.filter(item => item.email !== value?.events[0].organizer && item.email.toLowerCase() !== value?.events[0].organizer.toLowerCase()).map(item => ({
                    email: item.email,
                    responseStatus: item.status === "NEEDS-ACTION" ? "needsAction" :
                        item.status === "TENTATIVE" ? "tentative" :
                            item.status === "ACCEPTED" ? "accepted" :
                                item.status === "DECLINED" ? "declined" :
                                    item.status
                }));
                const AttendeesDetailsData = processAtteDetailsEmails(onlyAttendees, data)
                setSelectedItems(AttendeesDetailsData)
                const startFrom = ZohoDateTimeForTimeZone(value?.events[0]?.dateandtime?.start)
                const endTo = ZohoDateTimeForTimeZone(value?.events[0]?.dateandtime?.end)
                const formatedDesc = value?.events[0]?.description ? BodywithLinks(value?.events[0]?.description) : "";
                const startTimeDate = convertFromUTCAndFormat1(startFrom, profile)
                const endTimeDate = convertFromUTCAndFormat1(endTo, profile)
                const FinalData = {
                    ...value.events[0],
                    description: formatedDesc,
                    startDate: startTimeDate.date,
                    startTime: startTimeDate.time,
                    endDate: endTimeDate.date,
                    endTime: endTimeDate.time,
                };
                setDisplayData(FinalData)
            }
        }
    }
    async function getData(id) {
        try {
            const response = await fetchCalendarEventDetail(id);
            setData(response)
        } catch (error) {
            handleClose()
            message.error("The meeting you’re trying to access has been deleted or is no longer available");
        }
    }
    useEffect(() => {
        if (modelOpen) {
            if (Meeting) {
                getData(Meeting)
            }
        }
    }, [Meeting, modelOpen])
    async function saveMeetingNotes(params) {
        let hideMessage;
        try {
            hideMessage = message.loading("Loading...", 0);
            const formattedHtmlContent = params ? `<!DOCTYPE html PUBLIC "-//W3C//DTD HTML 4.01 Transitional//EN"><html><head><meta content="text/html;charset=UTF-8" http-equiv="Content-Type"><link href="https://fonts.googleapis.com/css2?family=Noto+Sans:ital,wght@0,100..900;1,100..900&family=Story+Script&display=swap"rel="stylesheet"></head><body><div>${params}</div></body></html>` : params;
            await addMeetingNote(displayData?.meetingActivityId, formattedHtmlContent)
            hideMessage();
            if (type === "Meeting") {
                reFetchData1()
            }
            message.success("Notes updated")
            getData(Meeting)
        }
        catch (error) {
            hideMessage();
            message.error(error)
        }
    }
    const openNotes = () => {
        const defaultTemplate = `
    <div><strong style="color: #5a5a5a;">Meeting Purpose / Agenda:</strong></div>
    <div><span class="placeholder">[Agenda item 1]</span></div>
    <div>&nbsp;</div>
    <div><strong style="color: #5a5a5a;">Discussion / Notes:</strong></div>
    <div><span class="placeholder">[Topic 1]</span><span class="placeholder">[Key points discussed]</span><span class="placeholder">[Person responsible]</span><span class="placeholder">[Date]</span></div>
    <div>&nbsp;</div>
    <div><strong style="color: #5a5a5a;">Decisions Made:</strong></div>
    <div><span class="placeholder">[Decision 1]</span></div>
    <div>&nbsp;</div>
    <div><strong style="color: #5a5a5a;">Follow-ups / Next Steps:</strong></div>
    <div><span class="placeholder">[Action 1]</span> <span class="placeholder">[Owner]</span> <span class="placeholder">[Due Date]</span><br>
    </div>
    <div>&nbsp;</div>
    <div><strong style="color: #5a5a5a;">Additional Notes / Comments:</strong></div>
    <div><span class="placeholder">[Comments]</span></div>
    `;
        let notesValue = displayData?.meetingNotes || defaultTemplate;
        let modalInstance; // declare first

        const EditorWrapper = () => {
            const [content, setContent] = React.useState(notesValue);
            const handleChange = (val) => {
                notesValue = val;
                setContent(val);
                if (modalInstance?.update) {
                    modalInstance.update({
                        okButtonProps: {
                            disabled: !val.replace(/<[^>]*>/g, "").trim(),
                        },
                    });
                }
            };
            return (
                <TinyMCEEditor
                    placeholder="Enter notes here..."
                    content={content}
                    setContent={handleChange}
                    edit
                    page="TextBoxs"
                    height={400}
                    selectedEntity="A"
                />
            );
        };
        modalInstance = Modal.confirm({
            icon: false,
            width: 800,
            title: (
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <span>{displayData?.meetingNotes ? "Edit Notes" : "Add Notes"}</span>
                    <Button
                        type="text"
                        onClick={() => modalInstance.destroy()}
                        style={{ fontSize: 20, padding: 0, color: "black" }}
                    >
                        ✕
                    </Button>
                </div>
            ),
            content: <EditorWrapper />,
            okText: "Save",
            cancelText: "Delete",
            okButtonProps: {
                className: "button_colorsModal",
                disabled: !notesValue?.trim(),
            },
            cancelButtonProps: {
                className: "red_colorsModal",
                style: { display: displayData?.meetingNotes ? "" : "none" },
            },
            onOk() {
                return saveMeetingNotes(notesValue);
            },
            onCancel() {
                return saveMeetingNotes(null);
            },
        });
    };
    return (
        <>
            <Drawer
                className='Drawer-Header-Pages'
                bodyStyle={{ padding: 0 }}
                closable={false}
                placement="right"
                title="Meeting Details"
                open={modelOpen}
                width="70%"
                extra={
                    < Space >
                        <div className='Hover-Refresh2 back-hover1 able-style'
                            role="button"
                            tabIndex={0} title='Close'
                            onClick={() => handleClose1()}
                            onKeyDown={(event) => {
                                if (event.key === 'Enter' || event.key === ' ') {
                                    handleClose1()
                                }
                            }}
                            aria-label='Close'
                        > <CancelIcon width={24} height={24} /></div>
                    </Space >
                }
                footer={false}
            >
                {displayData ? <Scrollbars autoHide autoHideTimeout={500} autoHideDuration={200}>
                    <AddUser>
                        <div className="user-info-form">
                            <Form style={{ width: '100%' }} form={form} name="info" colon={false} >
                                <BasicFormWrapper>
                                    <div className="add-product-block">
                                        <div style={{ margin: 40 }}>
                                            <Row gutter={15}>
                                                <Col xs={24}>
                                                    <div className="add-product-content">
                                                        <Row gutter={30} style={{ padding: "0px 20px" }}>
                                                            <Col span={24} style={{ marginBottom: 20, display: "flex", justifyContent: "space-between", alignItems: "center" }} >
                                                                <div>
                                                                    <Form.Item label="Meeting Name">
                                                                        {emailCongifDetail?.emailType === "Google" ?
                                                                            displayData?.summary && displayData?.summary !== "" ? displayData.summary : "No Subject"
                                                                            : emailCongifDetail?.emailType === "Outlook" ?
                                                                                displayData?.subject && displayData?.subject !== "" ? displayData.subject : "No Subject"
                                                                                : emailCongifDetail?.emailType === "Zoho" ?
                                                                                    displayData?.title && displayData?.title !== "" ? displayData.title : "No Subject" :
                                                                                    displayData?.summary && displayData?.summary !== "" ? displayData.summary : "No Subject"}
                                                                    </Form.Item>
                                                                </div>
                                                                {/* {viwerType === "Attendee" &&
                                                                <div>
                                                                    <Form.Item label="Meeting Status">
                                                                        {meetingStatus === "tentative" ? "Tentative" :
                                                                            meetingStatus === "accepted" ? "Accepted" :
                                                                                meetingStatus === "declined" ? "Declined" : meetingStatus}
                                                                    </Form.Item>
                                                                </div>
                                                            } */}
                                                            </Col>
                                                            {/* {viwerType === "Attendee" && */}
                                                            <Col span={24} style={{ marginBottom: 20 }} >
                                                                <Form.Item label="Organizer">
                                                                    <div className='Div_flex'>
                                                                        <div className='share_image' title={`${orgDetails?.name} (${orgDetails?.type}) (Accepted)`} style={{ cursor: "default" }}>
                                                                            <span className={`image_icon2 ${orgDetails?.type === "Leads" ? "LeadIcon"
                                                                                : orgDetails?.type === "User" ? "UserIcon"
                                                                                    : orgDetails?.type === "Contacts" ? "ContactIcon" : ""}`}>
                                                                                {orgDetails?.name?.slice(0, 1).toUpperCase()}
                                                                            </span>
                                                                            <span>{`${orgDetails?.name?.substring(0, 10)}...`}</span>
                                                                            <FeatherIcon icon="thumbs-up" size={15} className="Svg" style={{ color: "green" }} />
                                                                        </div>
                                                                    </div>
                                                                </Form.Item>
                                                            </Col>
                                                            {/* } */}
                                                            <Col span={24} style={{ marginBottom: 20 }} >
                                                                <Form.Item label="Attendees">
                                                                    {selectedItems.length > 0 &&
                                                                        <div className='Div_flex'>
                                                                            {selectedItems?.map((item, index) => (
                                                                                <div className='share_image' key={index} title={`${item.name} (${item.type}) (${item.responseStatus === "accepted" ? "Accepted" :
                                                                                    item.responseStatus === "needsAction" ? "Not Accepted" :
                                                                                        item.responseStatus === "tentative" ? "Tentative" : "Declined"
                                                                                    })`} style={{ cursor: "default" }}>
                                                                                    <span className={`image_icon2 ${item.type === "Leads" ? "LeadIcon"
                                                                                        : item.type === "User" ? "UserIcon"
                                                                                            : item.type === "Contacts" ? "ContactIcon" : ""}`}>
                                                                                        {item?.name?.slice(0, 1).toUpperCase()}
                                                                                    </span>
                                                                                    <span>{`${item.name?.substring(0, 10)}...`}</span>
                                                                                    <FeatherIcon icon={item.responseStatus === "needsAction" ? "clock" : item.responseStatus === "accepted" ? "thumbs-up" :
                                                                                        item.responseStatus === "tentative" ? "smile" : "thumbs-down"}
                                                                                        style={{
                                                                                            color: item.responseStatus === "needsAction" ? "orange" : item.responseStatus === "accepted" ? "green" :
                                                                                                item.responseStatus === "tentative" ? "gray" : "red"
                                                                                        }}
                                                                                        size={15} className="Svg" />
                                                                                </div>
                                                                            ))}
                                                                        </div>
                                                                    }
                                                                </Form.Item>
                                                            </Col>
                                                            <Col span={24} style={{ marginBottom: 20, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                                                <div>
                                                                    <Form.Item label="Start Date">
                                                                        {displayData?.startDate}
                                                                        {/* {displayData?.startDate && profile?.dateFormate ? moment(displayData?.startDate).format(profile.dateFormate) : (displayData?.startDate && moment(displayData?.startDate).format("YYYY-MM-DD"))} */}
                                                                    </Form.Item>
                                                                </div>
                                                                <div>
                                                                    <Form.Item label="Start Time">
                                                                        {displayData?.startTime}
                                                                        {/* {displayData && convertTime(displayData?.startTime, profile.timeFormat ? profile.timeFormat : "24hrs")} */}
                                                                    </Form.Item>
                                                                </div>
                                                                <div>
                                                                    <FeatherIcon icon="arrow-right" size={40} style={{ marginTop: 5, marginLeft: -30 }} />
                                                                </div>
                                                                <div>
                                                                    <Form.Item label="End Date">
                                                                        {displayData?.endDate}
                                                                    </Form.Item>
                                                                </div>
                                                                <div>
                                                                    <Form.Item label="End Time">
                                                                        {displayData?.endTime}
                                                                    </Form.Item>
                                                                </div>
                                                            </Col>
                                                            <Col span={24} style={{ marginBottom: 20 }} >
                                                                <Form.Item label="Time Zone">
                                                                    {profile?.timeZone}
                                                                </Form.Item>
                                                            </Col>
                                                            <Col span={24} style={{ marginBottom: 20 }} >
                                                                <Form.Item label="Location">
                                                                    {meetingSource}
                                                                </Form.Item>
                                                            </Col>
                                                            <Col span={24} style={{ marginBottom: 20 }} >
                                                                <Form.Item label="Meeting Description">
                                                                    {(() => {
                                                                        const isGoogle = emailCongifDetail?.emailType === "Google";
                                                                        const isOutlook = emailCongifDetail?.emailType === "Outlook";
                                                                        const isZoho = emailCongifDetail?.emailType === "Zoho";

                                                                        const description = isGoogle
                                                                            ? displayData?.description
                                                                            : isOutlook
                                                                                ? displayData?.body?.content
                                                                                : isZoho
                                                                                    ? displayData?.description
                                                                                    : displayData?.description;

                                                                        const meetingLink = isGoogle
                                                                            ? displayData?.hangoutLink
                                                                            : isOutlook
                                                                                ? displayData?.onlineMeeting?.joinUrl || displayData?.onlineMeetingUrl
                                                                                : displayData?.hangoutLink;

                                                                        const hasDescription = description && description !== "";
                                                                        const hasLink = meetingLink && meetingLink !== "";
                                                                        const OgContent = description || "";
                                                                        const htmlTagRegex =
                                                                            /<\/?(b|strong|i|em|u|br|p|div|span|ul|ol|li|a|table|thead|tbody|tr|td|th|h[1-6])(?:\s[^>]*)?>/i;
                                                                        const isHtmlContent = htmlTagRegex.test(OgContent);
                                                                        let formattedHtml = OgContent;
                                                                        if (!isHtmlContent) {
                                                                            formattedHtml = OgContent
                                                                                .replace(/<((?:https?:\/\/)[^>\s]+)>/g, '<a href="$1" target="_blank" rel="noopener noreferrer">$1</a>')
                                                                                .replace(/\n/g, '<br>');
                                                                        }
                                                                        return (
                                                                            <div>
                                                                                {hasDescription && (
                                                                                    <p>
                                                                                        {/* {isOutlook || isZoho ? ( */}
                                                                                        <CustomHtmlParser html={formattedHtml} key={1} />
                                                                                        {/* ) : ( */}
                                                                                        {/* description */}
                                                                                        {/* )} */}
                                                                                    </p>
                                                                                )}

                                                                                {hasLink && (
                                                                                    <p>
                                                                                        <a href={meetingLink} target="_blank" rel="noopener noreferrer">
                                                                                            {meetingLink}
                                                                                        </a>
                                                                                    </p>
                                                                                )}

                                                                                {!hasDescription && !hasLink && <p>No Description</p>}
                                                                            </div>
                                                                        );
                                                                    })()}
                                                                </Form.Item>
                                                            </Col>
                                                            {displayData?.meetingActivityId ?
                                                                <>
                                                                    <Col span={24} style={{ marginBottom: 20 }} >
                                                                        <div>
                                                                            <div style={{ display: "flex", alignItems: "center", gap: "20px" }}>
                                                                                <div style={{
                                                                                    fontSize: "18px",
                                                                                    fontWeight: "600",
                                                                                    lineHeight: "22px"
                                                                                }}>Meeting Notes <InfoCircleOutlined style={{ fontSize: "14px", color: '#0000009c', cursor: 'pointer', margin: "0px 3px" }} title="Only meetings with recorded notes will count toward lead, contact, deal or account scoring. Adding notes increases the score weightage as it reflects meaningful engagement" /></div>
                                                                                {displayData?.meetingActivityId && displayData?.meetingNotes && displayData?.meetingNotes !== "" && displayData?.meetingNotes !== "null" && displayData?.meetingNotes !== "undefined" && (
                                                                                    <div className='Hover-Refresh2 back-hover1 able-style2'
                                                                                        role="button"
                                                                                        tabIndex={0} title='Edit'
                                                                                        onClick={() => openNotes()}
                                                                                        onKeyDown={(event) => {
                                                                                            if (event.key === 'Enter' || event.key === ' ') {
                                                                                                openNotes()
                                                                                            }
                                                                                        }}
                                                                                        aria-label='edit'
                                                                                    > <EditIcon width={16} height={16} /></div>
                                                                                )}
                                                                            </div>
                                                                        </div>
                                                                        <div style={{ marginTop: 10 }}>
                                                                            {displayData?.meetingNotes &&
                                                                                displayData?.meetingNotes !== "" &&
                                                                                displayData?.meetingNotes !== "null" &&
                                                                                displayData?.meetingNotes !== "undefined" ? (
                                                                                <CustomHtmlParser html={displayData?.meetingNotes} key={1} />
                                                                            ) : (
                                                                                <></>
                                                                            )}
                                                                        </div>
                                                                    </Col>
                                                                    {displayData?.meetingActivityId ? (
                                                                        displayData?.meetingNotes && displayData?.meetingNotes !== "" && displayData?.meetingNotes !== "null" && displayData?.meetingNotes !== "undefined" ? <></> :
                                                                            <div className='Hover-Refresh2 back-hover1 able-style2'
                                                                                role="button"
                                                                                tabIndex={0} title='Add'
                                                                                onClick={() => openNotes()}
                                                                                onKeyDown={(event) => {
                                                                                    if (event.key === 'Enter' || event.key === ' ') {
                                                                                        openNotes()
                                                                                    }
                                                                                }}
                                                                                aria-label='add'
                                                                            > <AddIcon width={20} height={20} marginRight={5} /> Add Note</div>) : ""}
                                                                </> : <></>}
                                                        </Row>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </div>
                                    </div>
                                </BasicFormWrapper>
                            </Form>
                        </div >
                    </AddUser>
                </Scrollbars> : <div className="spin">
                    <Spin />
                </div>
                }
            </Drawer >
        </>
    );
};

Popup.propTypes = {
    modelOpen: PropTypes.bool.isRequired,
    handleClose: PropTypes.func.isRequired,
    Meeting: PropTypes.string,
    emailCongifDetail: PropTypes.object,
    type: PropTypes.string,
    reFetchData1: PropTypes.func,
};

export default Popup;
